<template>
  <div class="row">
    <div class="col-md-5 px-gap" id="presentasePosting">
      <div
        id="db-persentase-sentimen"
        class="bg-white p-l-20 p-t-20 p-r-20 p-b-20 rounded shade"
        data-v-step="8"
        style="height: 100%"
      >
        <h5 align="center">Persentase Sentimen Posting</h5>
        <div
          class="btn-group btn-group-toggle m-t-10"
          data-toggle="buttons"
          align="center"
          v-if="display_tipe == 3"
        >
          <label
            class="btn btn-default fs-11"
            :class="[{ active: sentimen_toggle == 'medkon' }]"
            @click="sentimen_toggle = 'medkon'"
          >
            <input
              type="radio"
              name="sentimen-toggle"
              id="sentimen-toggle-medkon"
              v-model="sentimen_toggle"
              value="medkon"
            />
            Media Konvensional
          </label>
          <label
            class="btn btn-default fs-11"
            :class="[{ active: sentimen_toggle == 'medsos' }]"
            @click="sentimen_toggle = 'medsos'"
          >
            <input
              type="radio"
              name="sentimen-toggle"
              id="sentimen-toggle-medsos"
              v-model="sentimen_toggle"
              value="medsos"
            />
            Media Sosial
          </label>
        </div>
        <div class="p-t-10">
          <loader-component v-if="is_loading" />
          <div v-else>
            <div
              v-if="!data.data_sentimen_current"
              class="col-md-12 col-sm-12 col-lg-12"
            >
              <div
                class="alert alert-danger mt-3"
                id="errorApiEl"
                role="alert"
                align="center"
              >
                <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                Silahkan lakukan pencarian dengan parameter lain
              </div>
            </div>
            <pie-chart-component
              v-else
              :key="data.data_sentimen_key"
              :data="data.data_sentimen_current"
            />
          </div>
        </div>
        <div v-if="!is_loading" class="row">
          <div class="col-md-4 col-sm-4" align="center">
            <span>Sentimen Positif</span>
            <h5>
              <i class="bi bi-emoji-smile" />
              {{
                data.data_sentimen_persentase != null
                  ? sentimen_toggle == "medsos"
                    ? data.data_sentimen_persentase.positif
                        .toFixed(2)
                        .replace(".", ",")
                    : data.data_sentimen_persentase_formed.positif
                        .toFixed(2)
                        .replace(".", ",")
                  : 0
              }}%
            </h5>
          </div>
          <div class="col-md-4 col-sm-4" align="center">
            <span>Sentimen Netral</span>
            <h5>
              <i class="bi bi-emoji-neutral icon-netral" />
              {{
                data.data_sentimen_persentase != null
                  ? sentimen_toggle == "medsos"
                    ? data.data_sentimen_persentase.netral
                        .toFixed(2)
                        .replace(".", ",")
                    : data.data_sentimen_persentase_formed.netral
                        .toFixed(2)
                        .replace(".", ",")
                  : 0
              }}%
            </h5>
          </div>
          <div class="col-md-4 col-sm-4" align="center">
            <span>Sentimen Negatif</span>
            <h5>
              <i class="bi bi-emoji-frown" />
              {{
                data.data_sentimen_persentase != null
                  ? sentimen_toggle == "medsos"
                    ? data.data_sentimen_persentase.negatif
                        .toFixed(2)
                        .replace(".", ",")
                    : data.data_sentimen_persentase_formed.negatif
                        .toFixed(2)
                        .replace(".", ",")
                  : 0
              }}%
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-7 px-gap" id="sentimenTopic">
      <div
        id="db-data-persentase"
        class="bg-white p-l-20 p-t-20 p-r-20 pb-1 rounded shade"
        data-v-step="9"
        style="height: 100%"
      >
        <h5 align="center">
          Data Sentimen Posting per Topik
          <div class="pull-right" align="right">
            <div class="form-check form-check-inline switch">
              <input type="checkbox" v-model="show_table" id="pagesSwitch" />
              <label for="pagesSwitch">Tampilkan Tabel</label>
            </div>
          </div>
        </h5>

        <div
          class="btn-group btn-group-toggle m-t-10"
          data-toggle="buttons"
          align="center"
          v-if="display_tipe == 3"
        >
          <label
            class="btn btn-default fs-11"
            :class="[{ active: topik_toggle == 'medkon' }]"
            @click="topik_toggle = 'medkon'"
          >
            <input
              type="radio"
              name="topik-toggle"
              id="topik-toggle-medkon"
              v-model="topik_toggle"
              value="medkon"
            />
            Media Konvensional
          </label>
          <label
            class="btn btn-default fs-11"
            :class="[{ active: topik_toggle == 'medsos' }]"
            @click="topik_toggle = 'medsos'"
          >
            <input
              type="radio"
              name="topik-toggle"
              id="topik-toggle-medsos"
              v-model="topik_toggle"
              value="medsos"
            />
            Media Sosial
          </label>
        </div>
        <div class="p-t-10">
          <loader-component v-if="is_loading" />
          <div
            v-else-if="!is_loading && !data.data_topik_barchart_current"
            class="col-md-12 col-sm-12 col-lg-12"
          >
            <div
              class="alert alert-danger mt-3"
              id="errorApiEl"
              role="alert"
              align="center"
            >
              <strong>Mohon maaf, data tidak tersedia! </strong> <br />
              Silahkan lakukan pencarian dengan parameter lain
            </div>
          </div>
          <div v-else-if="show_table && !is_loading">
            <table-dynamic-component
              v-if="topik_toggle == 'medkon'"
              :key="10"
              :data_head="data.dt_head"
              :data_body="data.dt_body_current"
              :config="data.dt_config"
              table_class="table-bordered p-b-20"
              class="fade-in m-b-20"
            />
            <table-dynamic-component
              v-else
              :key="20"
              :data_head="data.dt_head"
              :data_body="data.data_topik_medsos.table_data"
              :config="data.dt_config"
              table_class="table-bordered p-b-20"
              class="fade-in m-b-20"
            />
          </div>

          <bar-chart-group-stacked-component
            v-else-if="!is_loading && !show_table && topik_toggle == 'medsos'"
            :key="data.data_topik_key"
            :series="
              topik_toggle == 'medkon'
                ? data.data_topik_barchart_current
                : data.data_topik_medsos.grafik_data
            "
            :topik="
              topik_toggle == 'medkon'
                ? data.data_topik
                : data.data_topik_medsos.data_topik
            "
            :barchart_id="'sentimen-medsos-per-topik'"
          />
          <div
            v-else-if="
              data.barchart_drilldown.groups.length == 0 &&
                !is_loading &&
                !show_table &&
                topik_toggle == 'medkon'
            "
            class="col-md-12 col-sm-12 col-lg-12"
          >
            <div
              class="alert alert-danger mt-3"
              id="errorApiEl"
              role="alert"
              align="center"
            >
              <strong>Mohon maaf, data tidak tersedia! </strong> <br />
              Silahkan lakukan pencarian dengan parameter lain
            </div>
          </div>
          <bar-chart-drilldown-component
            v-else-if="
              data.barchart_drilldown.groups.length > 0 &&
                !is_loading &&
                !show_table &&
                topik_toggle == 'medkon'
            "
            :topik="data.data_topik"
            :series="data.barchart_drilldown.series"
            :subseries="data.barchart_drilldown.subseries"
            :groups="data.barchart_drilldown.groups"
            :key="data.barchart_drilldown_key"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader_component from "@/views/components/loader.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import bar_chart_group_stacked from "@/views/components/chart/bar_chart_group_stacked.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import bar_chart_drilldown from "@/views/components/chart/bar_chart_drilldown.vue";

export default {
  name: "sentiment_post",
  components: {
    "loader-component": loader_component,
    "table-dynamic-component": table_dynamic,
    "pie-chart-component": pie_chart,
    "bar-chart-group-stacked-component": bar_chart_group_stacked,
    "bar-chart-drilldown-component": bar_chart_drilldown,
  },
  data() {
    return {
      show_table: false,
      sentimen_toggle:
        this.$store.getters.user.project.project_detail.display_tipe == 3 ||
        this.$store.getters.user.project.project_detail.display_tipe == 2
          ? "medkon"
          : "medsos",
      topik_toggle:
        this.$store.getters.user.project.project_detail.display_tipe == 3 ||
        this.$store.getters.user.project.project_detail.display_tipe == 2
          ? "medkon"
          : "medsos",
    };
  },
  props: {
    data: Object,
    is_loading: Boolean,
    is_mobile: Boolean,
    display_tipe: Number,
  },
  methods: {
    init: function() {
      this.data_sentimen = this.data.data_sentimen;
    },
  },
  watch: {
    sentimen_toggle() {
      if (this.sentimen_toggle == "medsos") {
        this.data.data_sentimen_current = this.data.data_sentimen;
      } else {
        this.data.data_sentimen_current = this.data.data_sentimen_formed;
      }
      this.data.data_sentimen_key++;
    },
  },
};
</script>
